var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "space-bottom" },
    [
      _c("div", { staticClass: "transblack-background" }),
      _vm._v(" "),
      _c(
        "jFloatingPrompt",
        { ref: "titleFloating", staticClass: "p__b--100" },
        [
          _c(
            "b-row",
            { staticClass: "jobTitleFloat" },
            [
              _c(
                "b-col",
                [
                  _c("h3", { staticClass: "c--blue" }, [
                    _vm._v(_vm._s(_vm.detail_sla.name))
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.flow_sla.duration.$error }
                    },
                    [
                      _c("label", [_vm._v("Duration (minutes) *")]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: {
                          "max-length": 25,
                          type: "number",
                          placeholder: "Duration"
                        },
                        model: {
                          value: _vm.$v.flow_sla.duration.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.flow_sla.duration, "$model", $$v)
                          },
                          expression: "$v.flow_sla.duration.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "c--blue" }, [
                    _vm._v("SLA Indicator")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm._l(_vm.$v.flow_sla.sla.$each.$iter, function(
                    type,
                    index
                  ) {
                    return _c(
                      "div",
                      { key: type.type.$model },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { cols: "3" } }, [
                              _c(
                                "div",
                                { staticClass: "m__t--7" },
                                [
                                  _c(
                                    "j-checkbox",
                                    {
                                      attrs: {
                                        checked: type.is_check.$model,
                                        disabled: false,
                                        "checked-value": true,
                                        "unchecked-value": false
                                      },
                                      model: {
                                        value: type.is_check.$model,
                                        callback: function($$v) {
                                          _vm.$set(type.is_check, "$model", $$v)
                                        },
                                        expression: "type.is_check.$model"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Type " +
                                          _vm._s(Number(index)) +
                                          " (%)\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    class: { "error-input": type.value.$error }
                                  },
                                  [
                                    _c("j-input", {
                                      attrs: {
                                        "max-length": 3,
                                        disabled: !type.is_check.$model,
                                        type: "number",
                                        placeholder: "Duration"
                                      },
                                      model: {
                                        value: type.value.$model,
                                        callback: function($$v) {
                                          _vm.$set(
                                            type.value,
                                            "$model",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "type.value.$model"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("b-col", { attrs: { cols: "2" } }, [
                _c(
                  "div",
                  { staticClass: "wrap-button-flow" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn blue",
                        on: { click: _vm.createFlowSLA }
                      },
                      [_vm._v("\n            SUBMIT\n          ")]
                    ),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-times",
                      on: {
                        click: function($event) {
                          _vm.$refs.titleFloating.hide("/flows")
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-170d628c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-170d628c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/flow-rule/flow/flow-sla/detail/jDetailFlowSLA.vue
// module id = null
// module chunks = 